// Google Maps JSON styling arrays, matched to the app's own light/dark palettes. Applied
// to every google-map-react instance (IncidentMap, DashboardMap, the location picker in
// Incident.jsx) based on the current theme mode — see useThemeMode() at each call site.

// Dark navy, matched to the app's dark-mode `ink` palette.
export const DARK_MAP_STYLE = [
    { featureType: 'all', elementType: 'geometry', stylers: [{ color: '#202c3e' }] },
    {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [{ gamma: 0.01 }, { lightness: 20 }, { weight: '1.39' }, { color: '#ffffff' }],
    },
    {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [{ weight: '0.96' }, { saturation: '9' }, { visibility: 'on' }, { color: '#000000' }],
    },
    { featureType: 'all', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    {
        featureType: 'administrative.country',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'on' }, { color: '#b91212' }],
    },
    // Border lines had no explicit stroke color before, so they fell back to Google's
    // default (barely visible against this dark palette) — give every admin level a
    // visible bright stroke.
    {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#6f90bf' }, { weight: 1.1 }, { visibility: 'on' }],
    },
    {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [{ lightness: 30 }, { saturation: '9' }, { color: '#2a3859' }],
    },
    {
        featureType: 'landscape.natural.landcover',
        elementType: 'all',
        stylers: [{ saturation: '0' }, { lightness: '7' }],
    },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ saturation: 20 }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ lightness: 20 }, { saturation: -20 }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ lightness: 10 }, { saturation: -30 }] },
    { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#3d5a82' }] },
    {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ saturation: 25 }, { lightness: 25 }, { color: '#6f90bf' }, { weight: 1 }],
    },
    { featureType: 'water', elementType: 'all', stylers: [{ lightness: '-44' }, { color: '#0f172a' }] },
];

// Light neutral, matched to the app's light-mode surfaces (neutral-50/100 canvas, seha
// navy text) — same rule structure as DARK_MAP_STYLE above so the two stay easy to
// compare/maintain side by side.
export const LIGHT_MAP_STYLE = [
    { featureType: 'all', elementType: 'geometry', stylers: [{ color: '#f4f6f9' }] },
    { featureType: 'all', elementType: 'labels.text.fill', stylers: [{ color: '#33415c' }] },
    {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { weight: 2 }],
    },
    { featureType: 'all', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    {
        featureType: 'administrative.country',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'on' }, { color: '#b91212' }],
    },
    {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#9fb0c9' }, { weight: 1.1 }, { visibility: 'on' }],
    },
    { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#eef1f5' }] },
    {
        featureType: 'landscape.natural.landcover',
        elementType: 'all',
        stylers: [{ saturation: -10 }, { lightness: 5 }],
    },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#e3ecdf' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#d7e6cf' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ saturation: -20 }] },
    { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }] },
    {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#c7d2e0' }, { weight: 1 }],
    },
    { featureType: 'water', elementType: 'all', stylers: [{ color: '#cfe3f5' }] },
];
